import { createSaga } from './saga-helpers';

import * as Api from '../api/goal-groups-api';

const watchGetGoalGroups = createSaga({
    type: 'GOAL_GROUPS_FETCH',
    fn: Api.fetchGoalGroups,
    args: action => [action.payload],
    successPayload: ({ data, hasMore } = {}, action) => ({
        items: data,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateGoalGroup = createSaga({
    type: 'GOAL_GROUP_CREATE',
    fn: Api.createGoalGroup,
    args: action => [action.payload.goalGroup],
    successPayload: ({ id: groupId }, action) => ({
        groupId,
        fragment: action.payload.goalGroup
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.goalGroup
    })
});

const watchGetGoalGroup = createSaga({
    type: 'GOAL_GROUP_FETCH',
    fn: Api.fetchGoalGroup,
    args: action => [action.payload.groupId],
    successPayload: goalGroup => ({ goalGroup })
});

const watchUpdateGoalGroup = createSaga({
    type: 'GOAL_GROUP_UPDATE',
    fn: Api.updateGoalGroup,
    args: action => [action.payload.groupId, action.payload.goalGroupProps],
    successPayload: goalGroup => ({ goalGroup })
});

const watchRemoveGoalGroup = createSaga({
    type: 'GOAL_GROUP_REMOVE',
    fn: Api.removeGoalGroup,
    args: action => [action.payload.groupId]
});

const sagas = [watchGetGoalGroups, watchCreateGoalGroup, watchGetGoalGroup, watchUpdateGoalGroup, watchRemoveGoalGroup];

export default sagas;
